export const DAY_ITEM_WIDTH = 115;
export const DAY_ITEMS_QTY = 60;
